module.exports = __webpack_public_path__ + "static/img/banner.343b993.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/jp/banner.png
// module id = /yXX
// module chunks = 1